// extracted by mini-css-extract-plugin
export default {"screenReaderOnly":"styles-module__screenReaderOnly__bde9dfaccc67743b8ee7"};